<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-08-18 14:23:54
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <div class="header">
        <div class="title">基本信息 Basic information</div>
        <!-- <div>
          <el-button type="primary" v-if="uploads">
            <i class="iconfont iconshangchuan"></i>上传附件分享地址
          </el-button>
          <el-button type="primary" @click="Export">
            <i class="iconfont icondaochu"></i>导出报名表
          </el-button>
        </div>-->
      </div>
      <div class="cont">
        <ul class="part1">
          <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.teamChorusCh">
              <template slot="prepend">合唱团名称：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamChorusEn">
              <template slot="prepend">Name of the group：</template>
            </el-input>
            <!-- <el-input placeholder="请输入内容" v-model="basce.baseCountryCh">
              <template slot="prepend">国家：</template>
            </el-input>-->
          </li>
          <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameCh">
              <template slot="prepend">省/城市：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameEn">
              <template slot="prepend">City:</template>
            </el-input>
          </li>
          <!-- <li class="three">
            <el-input placeholder="请输入内容" v-model="basce.baseStreetCh">
              <template slot="prepend">通讯地址：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameCh">
              <template slot="prepend">省/城市：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.baseZipCh">
              <template slot="prepend">州/省 邮政编码：</template>
            </el-input>
          </li>
          <li class="three">
            <el-input placeholder="请输入内容" v-model="basce.baseStreetEn">
              <template slot="prepend">Street：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamRegionNameEn">
              <template slot="prepend">City:</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.baseZipEn">
              <template slot="prepend">State/Province & Zip Code：</template>
            </el-input>
          </li>-->
          <li class="two">
            <el-input
              placeholder="（国家代码-城市区号-电话号码）"
              v-model="basce.teamPhoneCh"
            >
              <template slot="prepend">电话：</template>
            </el-input>
            <el-input
              placeholder="Country code / area code / number"
              v-model="basce.teamPhoneEn"
            >
              <template slot="prepend">Phone：</template>
            </el-input>
          </li>
          <!-- <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.baseFaxCh">
              <template slot="prepend">传真：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.baseFaxEn">
              <template slot="prepend">Fax：</template>
            </el-input>
          </li>-->
          <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.teamEmailCh">
              <template slot="prepend">电子邮箱：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamEmailEn">
              <template slot="prepend">E-mail：</template>
            </el-input>
          </li>
          <!-- <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.baseWebsiteCh">
              <template slot="prepend">合唱团网址：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.baseWebsiteEn">
              <template slot="prepend">Website：</template>
            </el-input>
          </li>-->
          <!-- <li class="two">
            <el-input
              placeholder="2020-12-24 09:24:07"
              v-model="basce.baseYearCh"
            >
              <template slot="prepend">合唱团成立年份：</template>
            </el-input>
                  <el-input
              placeholder="2020-12-24 09:24:07"
              v-model="basce.baseYearEn"
            >
              <template slot="prepend">Year choir was founded：</template>
            </el-input>
          </li>-->

          <li class="two">
            <el-input placeholder="请输入内容" v-model="basce.teamNumCh">
              <template slot="prepend">团队人数：</template>
            </el-input>
            <el-input placeholder="请输入内容" v-model="basce.teamNumEn">
              <template slot="prepend">Team size：</template>
            </el-input>
          </li>
        </ul>
        <el-form
          status-icon
          ref="ruleForm"
          label-width="auto"
          class="demo-ruleForm"
        >
          <template v-for="(item, index) in audata">
            <el-form-item
              :label="item.description + ':'"
              :class="{
                check_box: item.inputType == 'CheckBoxList' ? true : false,
              }"
            >
              <template v-if="item.inputType == 'SingleTextBox'">
                <input
                  type="text"
                  :class="item.name"
                  placeholder="请输入内容"
                />
              </template>
              <template v-if="item.inputType == 'MultiTextBox'">
                <textarea :class="item.name" placeholder="请输入内容" />
              </template>
              <template v-if="item.inputType == 'RichTextBox'">
                <input
                  type="text"
                  :class="item.name"
                  placeholder="请输入内容"
                />
              </template>
              <template v-if="item.inputType == 'DropDownList'">
                <el-select v-model="meForm[item.name]" placeholder="请选择">
                  <el-option
                    v-for="ites in options"
                    v-if="item.name == ites.name"
                    :key="ites.value"
                    :label="ites.label"
                    :value="ites.value"
                  ></el-option>
                </el-select>
                <input
                  type="text"
                  ref="drops"
                  v-model="meForm[item.name]"
                  :class="item.name"
                  hidden
                />
              </template>
              <template v-if="item.inputType == 'RadioButtonList'">
                <template
                  v-for="ites in radiovalue"
                  v-if="item.name == ites.name"
                >
                  <label style="float: left">
                    <el-radio-group v-model="meForm[item.name]">
                      <el-radio :label="ites.value"></el-radio>
                    </el-radio-group>
                  </label>
                </template>
                <input
                  type="text"
                  ref="radios"
                  v-model="meForm[item.name]"
                  :class="item.name"
                  hidden
                />
              </template>
              <template v-if="item.inputType == 'CheckBoxList'">
                <template>
                  <label class="checkboxlist" style="float: left">
                    <el-checkbox-group v-model="meForm[item.name]">
                      <el-checkbox
                        v-for="(ites, i) in checkvalue"
                        v-if="item.name == ites.name"
                        :key="i"
                        :label="ites.value"
                        >{{ ites.value }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </label>
                </template>
                <input
                  type="text"
                  ref="checks"
                  title="CheckBox"
                  v-model="meForm[item.name]"
                  :class="item.name"
                  hidden
                />
              </template>
              <!-- 文件上传 -->
              <template v-if="item.inputType == 'UpFile'">
                <template>
                  <label style="float: left">
                    <el-upload
                      class="upload-demo"
                      action
                      :name="item.name"
                      :show-file-list="false"
                      :http-request="myUpload"
                    >
                      <el-button size="small" type="primary">{{
                        meForm[item.name] ? meForm[item.name] : "上传"
                      }}</el-button>
                    </el-upload>
                  </label>
                  <input
                    type="text"
                    ref="checks"
                    v-model="meForm[item.name]"
                    :class="item.name"
                    hidden
                  />
                </template>
                <input
                  type="text"
                  ref="checks"
                  v-model="meForm[item.name]"
                  :class="item.name"
                  hidden
                />
              </template>
              <template v-if="item.inputType == 'DateTime'">
                <input type="text" :class="item.name" />
              </template>
            </el-form-item>
          </template>

          <!-- <el-form-item label="附件上传">
            <el-upload class="upload-demo" action :show-file-list="false" :http-request="myUpload">
              <el-button size="small" type="primary">上传</el-button>
            </el-upload>
          </el-form-item>-->
        </el-form>
        <ul class="bottoms" v-if="!tijiaoSucess">
          <el-button type="primary" @click="dialogTableVisible = true"
            >提交</el-button
          >
          <el-button type="primary" @click="submits(0)">保存</el-button>
          <el-button>取消</el-button>
        </ul>
      </div>
    </div>
    <el-dialog title="特别提示" :visible.sync="dialogTableVisible">
      <p class="tip">
        注：请确认信息是否正确的，
        <br />确认提交之后将无法修改报名信息！
      </p>
      <div class="btnbox">
        <button @click="submits(1)">确定</button>
        <button class="info" @click="dialogTableVisible = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="imports">
      <p class="tip">请确认是否导出</p>
      <div class="btnboxs">
        <button @click="Export">确定</button>
        <button class="info" @click="imports = false">取消</button>
      </div>
    </el-dialog>
    <el-dialog title="特别提示" :visible.sync="dialogVisible2">
      <span>
        已保存成功
        <br />
        {{ timee }} 秒后返回报名界面
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  apply_detail,
  applysubmit,
  templateup,
  upload,
  applyupdate,
  tplDetailById,
  addMetadataTemplate,
  // templatetype,
  listFormFieldByProjectId,
  applyExport,
} from "@/api/file"; // 接口导入
export default {
  props: {
    audata: {
      type: Array,
      default: () => {
        return [];
      },
    },
    audatastr: {
      type: Object,
      defaultL: () => {
        return {};
      },
    },
  },

  watch: {
    audata: {
      handler(newValue, oldValue) {
        console.log(newValue);
        let s = newValue;
        let spl = "";
        for (let i in s) {
          //如果返回是单选按钮
          if (s[i].inputType === "RadioButtonList") {
            if (s[i].defaultValue) {
              spl = s[i].defaultValue.split(",");
              for (let index in spl) {
                this.radiovalue.push({ value: spl[index], name: s[i].name });
              }
            }
          } else if (s[i].inputType === "CheckBoxList") {
            //如果是复选
            if (s[i].defaultValue) {
              spl = s[i].defaultValue.split(",");
              for (let index in spl) {
                this.checkvalue.push({ value: spl[index], name: s[i].name });
              }
              this.$set(this.meForm, s[i].name, []);
            }
          } else if (s[i].inputType === "DropDownList") {
            //如果是下拉
            if (s[i].defaultValue) {
              spl = s[i].defaultValue.split(",");
              for (let index in spl) {
                let das = {
                  value: spl[index],
                  label: spl[index],
                  name: s[i].name,
                };
                this.options.push(das);
              }
            }
          }
        }
        for (let i in this.audata) {
          this.addbox.key.push(this.audata[i].name);
        }
      },
      deep: true,
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      files: "",
      fileUrl: "",
      templateId: "",
      dialogTableVisible: false,
      dialogVisible2: false,
      uploads: false,
      imports: false,
      dialogVisible: false,
      value: "",
      activityName: "",
      teamNum: "",
      basce: {
        teamChorusCh: "", // 团队合唱团中文名称
        teamChorusEn: "",
        teamPhoneCh: "", //团队电话中文
        teamPhoneEn: "",
        teamEmailCh: "", //团队电子邮箱
        teamEmailEn: "",
        teamNumCh: "", //团队人数
        teamNumEn: "",
        teamRegionNameCh: "", // 团队地区
        teamRegionNameEn: "",
        baseCountryCh: "", //国家
        baseCountryEn: "",
        baseStreetCh: "", //住址
        baseStreetEn: "",
        baseZipCh: "", //邮政编码
        baseZipEn: "",
        baseFaxCh: "", //传真
        baseFaxEn: "",
        baseWebsiteCh: "", //网址
        baseWebsiteEn: "",
        baseYearCh: "", //年份
        baseYearEn: "",
      },
      timee: 3,
      addbox: {
        key: [],
        value: "",
      },
      templatetypes: "",
      radio: "",
      radios: "",
      checkList: [],
      radiovalue: [],
      checkvalue: [],
      drops: "",
      options: [],
      meForm: {},
      tijiaoSucess: false,
    };
  },

  created() {},
  mounted() {
    localStorage.setItem("states", 1);
    if (this.audata.length > 0) {
      this.xr();
    }
    this.getcontent();
  },
  methods: {
    //得到已提交的内容
    getcontent() {
      this.basce.teamChorusCh = this.audatastr.teamChorusCh;
      this.basce.teamChorusEn = this.audatastr.teamChorusEn;
      this.basce.teamPhoneCh = this.audatastr.teamPhoneCh;
      this.basce.teamPhoneEn = this.audatastr.teamPhoneEn;
      this.basce.teamEmailCh = this.audatastr.teamEmailCh;
      this.basce.teamEmailEn = this.audatastr.teamEmailEn;
      this.basce.teamNumCh = this.audatastr.teamNumCh;
      this.basce.teamNumEn = this.audatastr.teamNumEn;
      this.basce.teamRegionNameEn = this.audatastr.teamRegionNameEn;
      this.basce.teamRegionNameCh = this.audatastr.teamRegionNameCh;
    },
    //得到自定义表单并渲染
    xr() {
      let s = this.audata;
      let spl = "";
      for (let i in s) {
        //如果返回是单选按钮
        if (s[i].inputType === "RadioButtonList") {
          if (s[i].defaultValue) {
            spl = s[i].defaultValue.split(",");
            for (let index in spl) {
              // this.radiovalue.push(spl[i]);
              this.radiovalue.push({ value: spl[index], name: s[i].name });
            }
          }
        } else if (s[i].inputType === "CheckBoxList") {
          //如果是复选
          if (s[i].defaultValue) {
            spl = s[i].defaultValue.split(",");
            for (let index in spl) {
              this.checkvalue.push({ value: spl[index], name: s[i].name });
            }
            this.$set(this.meForm, s[i].name, []);
          }
        } else if (s[i].inputType === "DropDownList") {
          //如果是下拉
          if (s[i].defaultValue) {
            spl = s[i].defaultValue.split(",");
            for (let index in spl) {
              let das = {
                value: spl[index],
                label: spl[index],
                name: s[i].name,
              };
              this.options.push(das);
            }
          }
        }
      }
      for (let i in this.audata) {
        this.addbox.key.push(this.audata[i].name);
      }
    },
    //图片上传
    myUpload(params) {
      // console.log(params.filename);
      let formData = new FormData();
      formData.append("file", params.file);
      upload(formData).then((res) => {
        if (res.code == 200) {
          this.$message.success("上传成功");
          this.$set(this.meForm, params.filename, res.data.fileUrl);
        }
      });
    },
    //导出报名表
    Export() {
      tplDetailById(localStorage.getItem("templateId")).then((res) => {
        window.open(res.data.fileUrl);
      });
      // let id = localStorage.getItem("id");
      // applyExport(id).then((res) => {
      //   //检查了下才发现，后端对文件流做了一层封装，所以将content指向res.data即可
      //   //另外，流的转储属于浅拷贝，所以此处的content转储仅仅是便于理解，并没有实际作用=_=
      //   const content = res.data;
      //   const blob = new Blob([content], { type: "application/pdf" }); //构造一个blob对象来处理数据
      //   const fileName = "test.pdf";

      //   // //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //   // //IE10以上支持blob但是依然不支持download
      //   if ("download" in document.createElement("a")) {
      //     //支持a标签download的浏览器
      //     const link = document.createElement("a"); //创建a标签
      //     link.download = fileName; //a标签添加属性
      //     link.style.display = "none";
      //     link.href = URL.createObjectURL(blob);
      //     document.body.appendChild(link);
      //     link.click(); //执行下载
      //     URL.revokeObjectURL(link.href); //释放url
      //     document.body.removeChild(link); //释放标签
      //   } else {
      //     //其他浏览器
      //     navigator.msSaveBlob(blob, fileName);
      //   }
      // });
    },

    //提交保存申请
    submits(states) {
      let data = {
        templateId: localStorage.getItem("templateId"),
        activityId: localStorage.getItem("activityId"),
        state: states,
        teamChorusCh: this.basce.teamChorusCh,
        teamChorusEn: this.basce.teamChorusEn,
        teamPhoneCh: this.basce.teamPhoneCh,
        teamPhoneEn: this.basce.teamPhoneEn,
        teamEmailCh: this.basce.teamEmailCh,
        teamEmailEn: this.basce.teamEmailEn,
        teamNumCh: this.basce.teamNumCh,
        teamNumEn: this.basce.teamNumEn,
        teamRegionNameEn: this.basce.teamRegionNameEn,
        teamRegionNameCh: this.basce.teamRegionNameCh,
        fileUrl: this.fileUrl,
        jsonObject: {},
        // baseWebsiteCh: this.basce.baseWebsiteCh ,
        // baseWebsiteEn: this.basce.baseWebsiteEn,
        // baseYearCh: this.basce.baseYearCh,
        // baseYearEn: this.basce.baseYearEn,
        // baseStreetCh: this.basce.baseStreetCh,
        // baseStreetEn: this.basce.baseStreetEn,
        // baseCountryCh: this.basce.baseCountryCh,
        // baseCountryEn: this.basce.baseCountryEn,
        // baseZipCh: this.basce.baseZipCh,
        // baseZipEn: this.basce.baseZipEn,
        // baseFaxCh: this.basce.baseFaxCh,
        // baseFaxEn: this.basce.baseFaxEn,
      };
      // console.log(data);
      if (!data.teamChorusCh) {
        this.$message({
          showClose: true,
          message: "合唱团名称为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamChorusEn) {
        this.$message({
          showClose: true,
          message: "Name of the group为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamPhoneCh) {
        this.$message({
          showClose: true,
          message: "电话为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamPhoneEn) {
        this.$message({
          showClose: true,
          message: "Phone为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamEmailCh) {
        this.$message({
          showClose: true,
          message: "电子邮箱为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamEmailEn) {
        this.$message({
          showClose: true,
          message: "E-mail为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamNumCh) {
        this.$message({
          showClose: true,
          message: "团队人数为必填字段",
          type: "error",
        });
        return;
      }
      if (!data.teamNumEn) {
        this.$message({
          showClose: true,
          message: "Team size为必填字段",
          type: "error",
        });
        return;
      }
      let add = this.addbox.key;
      for (let i in add) {
        //添加动态属性
        if (this.checkList.length > 0) {
          this.$refs.checks[0].value = this.checkList.toString();
        }
        if (this.drops != "") {
          this.$refs.drops[0].value = this.drops;
        }
        if (document.getElementsByClassName(add[i])[0].title == "CheckBox") {
          data.jsonObject[add[i]] = document.getElementsByClassName(
            add[i]
          )[0]._value;
        } else {
          data.jsonObject[add[i]] = document.getElementsByClassName(
            add[i]
          )[0].value;
        }
      }

      for (let key in data.jsonObject) {
        for (let i = 0; i < this.audata.length; i++) {
          if (key == this.audata[i].name && this.audata[i].requiredFlag) {
            if (
              data.jsonObject[key] instanceof Array &&
              !data.jsonObject[key].length
            ) {
              this.$message({
                showClose: true,
                message: this.audata[i].description + "为必填字段",
                type: "error",
              });
              return;
            }
            if (!data.jsonObject[key]) {
              this.$message({
                showClose: true,
                message: this.audata[i].description + "为必填字段",
                type: "error",
              });
              return;
            }
          }
        }
      }

      for (let key in data.jsonObject) {
        for (let i = 0; i < this.audata.length; i++) {
          if (key == this.audata[i].name && this.audata[i].verifyReg) {
            let reg = eval(this.audata[i].verifyReg);
            if (!reg.test(data.jsonObject[key])) {
              this.$message({
                showClose: true,
                message: this.audata[i].errorMsg,
                type: "error",
              });
              return;
            }
          }
        }
      }
      addMetadataTemplate(data).then((res) => {
        if (res.code == 200) {
          if (data.state == 0) {
            this.$message.success("保存成功");
            this.tijiaoSucess = true;
          } else {
            this.$message.success("提交成功");
            this.dialogTableVisible = false;
            this.tijiaoSucess = true;
          }
        }
      });
    },
    //模板2下载模板附件
    uploa() {
      templateup(this.templateId).then((res) => {
        window.location.href = res.data;
      });
      // window.location.href=this.activedetail.fileUrl
    },
    //模板2下载模板附件
    uploas() {
      window.location.href = this.activedetail.fileUrl;
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      width: 560px;
      height: 330px;
      border-radius: 12px;
      margin: 0 !important;
      .el-dialog__header {
        background: #24558b;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;

        .el-dialog__title {
          color: white;
        }

        .el-dialog__headerbtn {
          i {
            color: white;
          }
        }
      }

      .el-dialog__body {
        p {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fc524c;
          line-height: 52px;
          text-align: center;
        }

        span {
          display: inline-block;
          width: 100%;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #24558b;
          line-height: 48px;
          text-align: center;
          margin-top: 54px;
        }

        .btnboxs {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 50px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }

        .btnbox {
          display: flex;
          justify-content: space-evenly;
          width: 59%;
          margin: auto;
          margin-top: 20px;

          button {
            width: 100px;
            height: 42px;
            background: #24558b;
            border-radius: 8px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none; //消除默认点击蓝色边框效果
            cursor: pointer;
          }

          .info {
            background: #ffffff;
            border: 1px solid #a6aab8;
            color: #838a9d;
          }
        }
      }
    }
  }

  .box {
    margin: auto;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    margin-bottom: 42px;

    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin-top: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;
          .el-dialog__title {
            color: white;
          }

          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }

        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 118px;
            text-align: center;
          }

          span {
            display: inline-block;
            width: 100%;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }

          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;

            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }

            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }

    .header {
      display: flex;
      justify-content: space-between;
      width: 90%;
      margin: 48px 48px;

      .title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3c4353;
      }
    }

    .cont {
      .bottoms {
        width: 100%;
        // height: 132px;
        // margin-top: 96px;
        // box-shadow: 0px 0px 10px 0px rgba(8, 27, 42, 0.1);
        display: flex;
        justify-content: center;

        .el-button {
          height: 42px;
          margin-left: 50px;
          margin-top: 57px;
        }
      }
      .uploadform {
        display: flex;
        height: 60px;
        justify-content: space-between;
        padding-left: 100px;
        padding-right: 100px;
        margin-top: 10px;
        //  box-shadow: 0px 0px 10px 0px rgba(8, 27, 42, 0.1);
        div {
          height: 60px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #167afc;
          line-height: 60px;
          cursor: pointer;
          p {
            font-size: 16px;
          }
          /deep/ .el-upload-list {
            display: none;
          }
        }
      }
      .part1 {
        .texterar {
          div {
            width: 100%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-textarea {
              min-height: 200px;

              /deep/.el-textarea__inner {
                min-height: 200px !important;
              }
            }
          }
        }

        .listdiv {
          display: flex;
          justify-content: space-between;

          div {
            width: 30%;

            label {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #3c4353;
              line-height: 34px;
            }

            .el-input {
              width: 100%;
            }

            .el-select {
              width: 100%;
            }
          }
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;
          div {
            width: 50%;
          }
          .el-input {
            /deep/ .el-input-group__prepend {
              border-right: 0;
              color: rgba(36, 85, 139, 1);
              background: white;
              padding-right: 0px;
            }
            /deep/.el-input__inner {
              border-left: 0;
              padding: 0 15px 0 0;
              &:focus {
                border-color: #dcdfe6;
                outline: 0;
              }
            }
          }
        }
        .three {
          div {
            width: 33.5% !important;
          }
          .el-input-group--prepend {
            // &:last-of-type {
            //   width: 50%;
            // }
            &:nth-of-type(1) {
              width: 70%;
            }
            &:nth-of-type(2) {
              width: 30%;
            }
            &:nth-of-type(3) {
              width: 50%;
            }
          }
        }
        .two {
          .el-input-group--prepend {
            &:last-of-type {
              width: 50%;
            }
          }
        }

        li:nth-child(3) {
          margin-top: 30px;
        }

        li:nth-child(5) {
          margin-top: 30px;
        }

        li:nth-child(7) {
          margin-top: 30px;
        }

        li:nth-child(9) {
          margin-top: 30px;
        }

        li:nth-child(11) {
          margin-top: 30px;
        }
      }

      .part2 {
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #3c4353;
          margin: 48px 48px;
        }

        li {
          display: flex;
          padding-left: 100px;
          padding-right: 100px;
          margin-top: 20px;

          /deep/ .el-input-group__prepend {
            border-right: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
          }

          .radiobox {
            width: 30%;
            border: 1px solid gainsboro;

            .el-radio {
              margin-left: 30px;
              margin-top: 14px;
            }
          }
        }

        li:nth-of-type(3) {
          margin-top: 30px;
        }

        li:nth-of-type(5) {
          margin-top: 30px;
        }
      }
    }
  }
}
.demo-ruleForm {
  width: calc(100% - 200px);
  display: flex;
  flex-wrap: wrap;
  // flex-direction: column;
  // padding-left: 100px;
  // padding-right: 100px;
  float: left;
  margin: auto;
  padding-left: 100px;
  input {
    border: 1px solid gainsboro;
    width: 100%;
    padding-left: 10px;
    height: 32px;
    border-radius: 5px;
    outline: none;
  }
  label {
    display: flex;
    input {
      width: 50px;
      height: 20px;
      line-height: 20px;
      margin-top: 10px;
    }
  }
  .check_box {
    display: flex;
    ::v-deep.el-form-item__content {
      // overflow: hidden;
      overflow: auto;
      display: flex;
      &::-webkit-scrollbar {
        width: 10px;
        height: 4px;
      }
      &::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #333;
      }
      &::-webkit-scrollbar-corner {
        background: #179a16;
      }
    }
  }

  textarea {
    border: 1px solid gainsboro;
    width: 100%;
    height: 40px;
    outline: none;
  }
  .el-form-item {
    width: 49.8%;
    height: 40px;
    border: 1px solid gainsboro;
    border-radius: 4px;
    margin-top: 20px;
    display: flex;
    ::v-deep .el-form-item__label-wrap {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      float: left;
      color: #24558b;
      margin-left: 20px !important;
    }
    ::v-deep .el-form-item__content {
      flex: 1;
      margin-left: 0 !important;
      > input {
        width: 100%;
        padding-left: 0px !important;
        border: none;
      }
      .el-checkbox-group {
        display: flex;
      }
    }
  }
}
.demo-ruleForm label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 7px;
  margin-left: 5px;
}
</style>
